module.exports = {} /** This module can only be imported on the server */;